import { api } from "../intreceptor/apiInterceptor";

// Interface definitions for report types
export interface ReportType {
    reportType: string;
}

export interface ReportQueryParams {
    sector?: string[];
    province?: string[];
    status?: string[];
    localUnion?: string[];
    unionStatus?: string[];
    organizer?: string[];
    jobsite?: string[];
    startDate?: string;
    endDate?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    page?: number;
    limit?: number;
    month?: number[];
    year?: number[];
    type?: string[];
}

export interface JobSiteProgressReport {
    type?: string;
    jobId?: string;
    jobSiteName: string;
    sector: string;
    province: string;
    address: {
        address1: string;
        address2?: string;
        city: string;
        postalCode: string;
    } | null;
    status: string;
    contractorName: string;
    contractorEmail: string;
    unionType: string;
    totalWorkers: string;
    jobSiteProgress: string;
    localUnion: number[];
    startDate: string;
    lastUpdated: string;
    notes: string[];
    organizername: string;
    jobsite: string;
    contractor: string;
    completionStatus: string;
    visitDate: string;
    unionStatus: string;
    localUnions: {
        code: string;
        unionNumber: string;
    }[];
}

export interface ReportResponse {
    data: JobSiteProgressReport[];
    totalCount: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface JobSitesByUnion {
    id: string;
    // Add specific fields based on your requirements
    created_at: string;
    updated_at: string;
}

export interface OrganizerMonthlyActivity {
    id: string;
    // Add specific fields based on your requirements
    created_at: string;
    updated_at: string;
}

export interface OrganizerJobsites {
    id: string;
    // Add specific fields based on your requirements
    created_at: string;
    updated_at: string;
}

export const reportsService = {
    async getReportTypes(): Promise<ReportType[]> {
        return api.fetch('/reports/types');
    },

    async getAvailableYears(): Promise<{ id: string; name: string }[]> {
        return api.fetch('/reports/availableYears');
    },

    async getJobSiteProgressReport(params: ReportQueryParams): Promise<ReportResponse> {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => searchParams.append(key, v));
            } else if (value !== undefined) {
                searchParams.append(key, value.toString());
            }
        });
        return api.fetch(`/reports/jobSiteProgressReport?${searchParams.toString()}`);
    },

    async getJobSitesByUnion(params: ReportQueryParams): Promise<ReportResponse> {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => searchParams.append(key, v));
            } else if (value !== undefined) {
                searchParams.append(key, value.toString());
            }
        });
        return api.fetch(`/reports/jobSitesByUnion?${searchParams.toString()}`);
    },

    async getOrganizerMonthlyActivity(params: ReportQueryParams): Promise<ReportResponse> {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => searchParams.append(key, v));
            } else if (value !== undefined) {
                if (key === 'month' && typeof value === 'string') {
                    searchParams.append(key, value);
                } else {
                    searchParams.append(key, value.toString());
                }
            }
        });
        return api.fetch(`/reports/organizerMonthlyActivity?${searchParams.toString()}`);
    },

    async getOrganizerJobsites(params: ReportQueryParams): Promise<ReportResponse> {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => searchParams.append(key, v));
            } else if (value !== undefined) {
                searchParams.append(key, value.toString());
            }
        });
        return api.fetch(`/reports/organizerJobsites?${searchParams.toString()}`);
    },

    async getJobsiteVisits(params: ReportQueryParams): Promise<ReportResponse> {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => searchParams.append(key, v));
            } else if (value !== undefined) {
                searchParams.append(key, value.toString());
            }
        });
        return api.fetch(`/reports/jobsiteVisits?${searchParams.toString()}`);
    }
};
